import { Button } from '@/components/ui/button';
import { useTheme } from '@/hooks/useTheme';
import { useSpookySounds } from '@/hooks/useSpookySounds';
import { Ghost, Moon, Skull, Volume2, VolumeX } from 'lucide-react';

export function ScaryModeToggle() {
  const { theme, setTheme } = useTheme();
  const { soundEnabled, setSoundEnabled } = useSpookySounds();

  const modes = [
    { id: 'light', label: 'Calm', icon: Moon, className: '' },
    { id: 'dark', label: 'Scary', icon: Ghost, className: 'animate-pulse' },
    { id: 'nightmare', label: 'Nightmare', icon: Skull, className: 'animate-bounce' },
  ] as const;

  const currentModeIndex = modes.findIndex(mode => mode.id === theme);

  const cycleMode = () => {
    const nextIndex = (currentModeIndex + 1) % modes.length;
    setTheme(modes[nextIndex].id);
  };

  const currentMode = modes[currentModeIndex];
  const Icon = currentMode.icon;

  return (
    <div className="flex items-center gap-3">
      <Button
        onClick={cycleMode}
        variant="outline"
        className="bg-card/80 backdrop-blur-sm border-primary/30 px-4 py-2 h-auto"
      >
        <Icon className={`h-5 w-5 text-primary ${currentMode.className}`} />
        <span className="ml-2 text-sm font-medium">{currentMode.label} Mode</span>
      </Button>

      {(theme === 'dark' || theme === 'nightmare') && (
        <Button
          variant="outline"
          size="icon"
          onClick={() => setSoundEnabled(!soundEnabled)}
          className="bg-card/80 backdrop-blur-sm border-primary/30"
        >
          {soundEnabled ? (
            <Volume2 className="h-4 w-4" />
          ) : (
            <VolumeX className="h-4 w-4" />
          )}
        </Button>
      )}
    </div>
  );
}
